<template>
  <div
    class="box-body bg-fff"
    :style="'margin-bottom: ' + footbottom + 'px;'"
  >
    <div class="container" id="app">
      <h2 class="t-center mt-20 bold pa-tb-20">我的作品</h2>
      <img
        src="../img/merge/myc1.png"
        alt=""
        srcset=""
        width="100%"
        class="mt-10"
      />
      <div class="pa-b-20" v-if="tableData.length>0">
        <div v-for="(item,index) in tableData" :key="index" class="flex pa-20 b-b-1-e3">
          <div class="width90 fon-14">
            <div>
              <div class="flex">
              <div class="width50">作品名称： <span class="">{{ item.Title }}</span></div>
              <div class="width50">作品编号： <span class="">NO.{{ item.Code }}</span></div>
            </div>
            <div class="flex">
              <div class="width50">报名状态： <span class="">{{ item.Status }}</span></div>
              <div class="width50">报名时间： <span class="">{{ item.InsertTime }}</span></div>
            </div>
            </div>
            <div class="">
              <div class="flex" v-for="(item1,index1) in item.Competition" :key="index1">
                <div class="width50">作品状态： <span class="">{{ item1.Status }}</span></div>
                <div class="width50">参赛项目： <span class="">{{ item1.Name }}</span></div>
              </div>
            </div>
          </div>
          <div class="width10">
            <div
                class="btn-up ml-10 c-p"
                @click="pupupShow(item)"
                v-if="item.Status == '已报名'"
              >
                在线上传
              </div>
          </div>
        </div>
      </div>
      
        <Empty  class="height50" :isShow="tableData.length == 0"></Empty>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "../../css/bootstrap.min.css";
  @import "../../css/commons.css";

  .flex-1 {
    flex-grow: 1;
  }

  .body-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
  }

  .titles-right:before {
    content: "|";
    display: inline-block;
    width: 4px;
    height: 19px;
    background: #234775;
    color: #234775;
    border-radius: 2px;
    margin-right: 8px;
  }

  .width920px {
    width: 920px;
  }

  .font-style {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }

  .tab-active {
    border-bottom: 2px solid #234775;
  }

  .img_230 {
    width: 100%;
    height: 300px;
  }

  .btn-down {
    border: 1px solid #fb004d;
    color: #fb004d;
    width: 80px;
    text-align: center;
    line-height: 30px;
    border-radius: 5px;
  }

  .btn-down a {
    text-decoration: none;
  }

  .btn-down a:hover {
    color: #fb004d;
  }

  .btn-up {
    margin: 0 auto;
    background: #fb004d;
    color: #fff;
    width: 80px;

    text-align: center;
    line-height: 30px;
    border-radius: 5px;
  }

  .c-p {
    cursor: pointer;
  }

  .c-red {
    color: #fb004d;
  }

  .my-page-item {
    padding: 10px;
    border: 1px solid #eeeeee;
    cursor: pointer;
  }

  .my-pagination {
    display: flex;
  }

  .my-page-item-1:hover {
    background-color: #eeeeee;
  }

  .my-pagination li {
    list-style: none;
  }

  .disabled {
    background-color: none;
  }

  .active {
    background-color: #fb004d;
    color: #fff;
  }

  .pupup-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #00000080;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 4;
  }

  .pupup-box-i {
    width: 500px;
    height: auto;
    padding: 20px;
    background-color: #fff;
  }

  .pupup-box-i input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    width: 100%;
  }

  .btn-submit-1 {
    background: #fb004d;
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    margin: 0 auto;
    color: #fff;
    cursor: pointer;
    margin-top: 10px;
  }

  .btn-submit-2 {
    border: 1px solid #fb004d;
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    margin: 0 auto;
    color: #fb004d;
    cursor: pointer;
    margin-top: 10px;
  }

  .hidden-2 {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .child-table {
    background-color: #f8f8f8;
  }

  .child-td {
    height: 70px;
    line-height: 70px;
    width: 180px;
    text-align: center;
  }

  .demo-table-expand {
    background-color: #234775;
    padding: 0px;
  }
</style>
<script>
  import { getCompetitionList,RefundApply } from "../api.js";
  export default {
    name: "merge",
    data() {
      return {
        formData: {
          Id: null,
          WorkUrl: null,
          WorkPwd: null,
          Title: null,
          token: localStorage.getItem("AccessToken"),
          Type: 0,
        },
        dataList: [],
        pageindex: 1,
        pagesize: 10,
        pageIndex: 1, //当前页数
        TotalPages: 0, //总页数
        tableData: [],
        footbottom: 123,
      };
    },
    created() {
      console.log("开始开发");
      this.loadData();
      
    },

    methods: {
      //申请退款
      pupupShowRefundApply(row) {
        this.$prompt( "是否确认退款？", {
          confirmButtonText: "确定",
          inputPlaceholder:'请入退款理由(必填)'
        }).then(({value}) => {
              RefundApply({ id: row.Id ,Reason:value}).then(()=>{
                  this.loadData();
              })
          }).catch(()=>{
              console.log('取消输入')
          })
      },
      //跳转链接
      toBanerHref() {
        let i = this.$refs.carousel.activeIndex;
        let item = this.bannerlist[i];
        console.log(item);
        if (!item.Href) {
          return;
        } else {
          location.href = item.Href;
        }
      },
      //页面跳转
      pupupShow(row) {
        var typeId = "0";
        var hrefP = "";

        if (row.SignType == "短片奖报名信息") {
          typeId = "0";
        } else if (row.SignType == "剧本大赛") {
          typeId = "1";
        } else if (row.SignType == "影评人大赛") {
          typeId = "2";
        } else if (row.SignType == "艺术家短片展") {
          typeId = "3";
        } else if (row.SignType == "短片@音乐实验室") {
          typeId = "4";
        } else if (row.SignType == "SHISW翠麟表演艺术奖") {
          typeId = "5";
          hrefP = "&step=2";
        } else {
          this.$message.error("当前类型无法报名，请联系管理员");
          return;
        }
        var url =
          "/merge/fill-form?Id=" + row.Id + "&typeId=" + typeId + "" + hrefP;
        this.$router.push(`${url}`);
      },
      //获取数据
      loadData() {
        let data = {
          token: localStorage.getItem("AccessToken"),
          // pageindex: _this.pageIndex,
          // pagesize: _this.pagesize
        };
        getCompetitionList(data).then((res) => {
          console.log(res);
          this.dataList = res.data.Data.List;
          this.tableData = res.data.Data.List;
        });
      },
      //翻页
      toPage(i) {
        if (i == 0 || i == this.TotalPages + 1) {
          return;
        }
        this.pageIndex = i;
        this.loadData();
      },
    },
  };
</script>
